import * as React from 'react';
import { InlineText3 } from '@cian/ui-kit';
import * as styles from './Promo.css';

interface IPromoProps {
  label: string;
}

export function Promo({ label }: IPromoProps) {
  return (
    <mark className={styles['promo']}>
      <InlineText3 color="white_100">{label}</InlineText3>
    </mark>
  );
}
